import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { MemberProvider } from "@/context/MemberContext";
import AdminLayout from "@/components/AdminLayout";
import StoreLayout, { MemberRoute } from "@/components/store/StoreLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Categories from "@/pages/Categories";
import Orders from "@/pages/Orders";
import Customers from "@/pages/Customers";
import Discounts from "@/pages/Discounts";
import Settings from "@/pages/Settings";
import Landing from "@/pages/store/Landing";
import Register from "@/pages/store/Register";
import StoreLogin from "@/pages/store/StoreLogin";
import VerifyEmail from "@/pages/store/VerifyEmail";
import { ForgotPassword, ResetPassword } from "@/pages/store/PasswordRecovery";
import Shop from "@/pages/store/Shop";
import ProductDetail from "@/pages/store/ProductDetail";
import Cart from "@/pages/store/Cart";
import Checkout from "@/pages/store/Checkout";
import OrderDetail from "@/pages/store/OrderDetail";
import Account from "@/pages/store/Account";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex h-screen items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MemberProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<StoreLogin />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route element={<MemberRoute><StoreLayout /></MemberRoute>}>
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/account" element={<Account />} />
                <Route path="/account/orders/:id" element={<OrderDetail />} />
              </Route>
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <Protected>
                    <AdminLayout />
                  </Protected>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="products" element={<Products />} />
                <Route path="categories" element={<Categories />} />
                <Route path="orders" element={<Orders />} />
                <Route path="customers" element={<Customers />} />
                <Route path="discounts" element={<Discounts />} />
                <Route path="settings" element={<Settings />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position={window.innerWidth < 640 ? "top-center" : "bottom-right"} richColors />
        </MemberProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
